import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";

import { cn } from "../../lib/utils";

const Checkbox = React.forwardRef(
  ({ className, checked, onCheckedChange, indeterminate, ...props }, ref) => (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "peer h-[18px] w-[18px] shrink-0 rounded-[5px] border-2 transition-all duration-150 ease-in-out",
        "border-gray-300 dark:border-white/20",
        "bg-transparent",
        "hover:border-[#1E4FCF] dark:hover:border-[#1E4FCF]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1E4FCF]/30 focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-40",
        "data-[state=checked]:bg-[#1E4FCF] data-[state=checked]:border-[#1E4FCF] data-[state=checked]:text-white",
        "data-[state=indeterminate]:bg-[#1E4FCF] data-[state=indeterminate]:border-[#1E4FCF] data-[state=indeterminate]:text-white",
        className,
      )}
      checked={indeterminate ? "indeterminate" : checked}
      onCheckedChange={onCheckedChange}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("flex items-center justify-center text-current")}
      >
        {indeterminate ? (
          <Minus className="h-3.5 w-3.5 stroke-[3]" />
        ) : (
          <Check className="h-3.5 w-3.5 stroke-[3]" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  ),
);
Checkbox.displayName = "Checkbox";

export { Checkbox };
